import * as React from "react";
const SvgFiBrandsCreativeCommonsShare = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-creative-commons-share_svg__a)">
      <path d="M20.507 3.493Q17.013 0 11.979 0q-4.95 0-8.443 3.493Q0 7.093 0 12q0 4.929 3.536 8.464Q7.113 24 11.979 24q4.97 0 8.592-3.557Q24 17.036 24 12t-3.493-8.507m-1.5 15.386q-2.98 2.936-6.986 2.936-4.029 0-6.943-2.914-2.913-2.893-2.914-6.9 0-3.963 2.936-6.942 2.829-2.893 6.921-2.893t6.943 2.893q2.871 2.829 2.871 6.942 0 4.134-2.828 6.878" />
      <path d="m16.907 8.571-2.615.001V5.958a.64.64 0 0 0-.193-.472.64.64 0 0 0-.472-.193h-6.6a.74.74 0 0 0-.427.225.61.61 0 0 0-.172.439v8.828a.64.64 0 0 0 .193.472.64.64 0 0 0 .472.192h2.614v2.615q0 .278.193.471a.64.64 0 0 0 .472.193h6.536a.64.64 0 0 0 .471-.193.64.64 0 0 0 .193-.471V9.235a.64.64 0 0 0-.193-.472.65.65 0 0 0-.472-.192m-6.622 0a.74.74 0 0 0-.406.225.62.62 0 0 0-.172.439v4.907H7.735V6.621h5.25v1.95zm5.979 8.829h-5.25V9.878h5.25z" />
    </g>
    <defs>
      <clipPath id="fi-brands-creative-commons-share_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsCreativeCommonsShare;
